module.exports = __webpack_public_path__ + "static/img/unionPay.6a62e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unionPay.png
// module id = AQBc
// module chunks = 27